import { CodeListBranchState, CodeListBranch } from 'app/area/codetable/list/types-store';

export const getDirectParentsList = (codeListBranch: CodeListBranch[], childId: number, parents: number[] = []): number[] =>
  filterOwnId(getDirectParentsListInternal(codeListBranch, childId, parents), childId);

const filterOwnId = (parents: number[] = [], id: number): number[] => parents.filter(parent => parent !== id);

const getDirectParentsListInternal = (codeListBranch: CodeListBranch[], childId: number, parents: number[] = []): number[] => {
  if (childId === undefined) {
    return parents;
  }

  const sourceBranch = codeListBranch.find(branch => branch.items.find(item => item.id === childId));
  const sourceItem = sourceBranch && sourceBranch.items.find(item => item.id === childId);

  if (!sourceItem) {
    return parents;
  }

  const newParents = [sourceItem.id, ...parents];

  return getDirectParentsListInternal(codeListBranch, sourceBranch.id, newParents);
};

export const setLoadingState = (branchesState: CodeListBranchState[], parents: number[], isLoading): CodeListBranchState[] => {
  return branchesState.map(branch => ({ ...branch, isUpdatingParent: parents.some(parent => parent === branch.id) ? isLoading : false }));
};
